<h3 mat-dialog-title class="title">
  {{
    data.isResizeEnabled
      ? ('catalog.common.cropAndResizeImage' | translate)
      : ('catalog.common.cropImage' | translate)
  }}
</h3>

<mat-dialog-content class="dialog-content">
  <div class="cropper-content" [hidden]="isLoadingImage">
    <div *ngIf="croppedImage && !data.isResizeEnabled" class="dimensions">
      {{ croppedImage.width }}px x {{ croppedImage.height }}px
    </div>
    <div class="dimensions-input-container" *ngIf="data.isResizeEnabled">
      <form [formGroup]="form">
        <mat-form-field>
          <mat-label>{{ 'catalog.common.width' | translate }}</mat-label>
          <input
            matInput
            type="number"
            formControlName="width"
            min="0"
            max="99999"
            data-qa-label="ResizeSelectedWith"
            [placeholder]="'catalog.common.width' | translate"
            txpNumbersOnly
          />
          <mat-error *ngIf="form.get('width').errors; let errors">
            <mat-error *ngIf="errors.max">
              {{ 'form.error.max' | translate:{ value: 99999 } }}
            </mat-error>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'catalog.common.height' | translate }}</mat-label>
          <input
            matInput
            type="number"
            min="0"
            max="99999"
            formControlName="height"
            data-qa-label="ResizeSelectedHeight"
            [placeholder]="'catalog.common.height' | translate"
            txpNumbersOnly
          />
          <mat-error *ngIf="form.get('height').errors; let errors">
            <mat-error *ngIf="errors.max">
              {{ 'form.error.max' | translate:{ value: 99999 } }}
            </mat-error>
          </mat-error>
        </mat-form-field>
        <txp-button
          class="resize-btn"
          data-qa-label="ResizeButton"
          [style]="buttonStyle.PRIMARY"
          (click)="resizeFileImage()"
          [disabled]="form.pristine || !form.valid"
        >
          {{ 'catalog.common.resize' | translate }}
        </txp-button>
      </form>

    </div>
    <image-cropper [imageFile]="data?.imageFile"
                   [maintainAspectRatio]="false"
                   [format]="data.imageType"
                   (imageCropped)="imageCropped($event)"
                   (imageLoaded)="imageLoaded($event)"
                   [imageChangedEvent]="imageChangedEvent"
    ></image-cropper>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <txp-button (click)="onAction(false)"
              data-qa-label="CancelButton"
              [style]="buttonStyle.SECONDARY"
              [disabled]="isLoadingImage">
      {{ 'form.button.cancel' | translate }}
  </txp-button>
  <txp-button data-qa-label="ContinueButton"
              [style]="buttonStyle.PRIMARY"
              [disabled]="!hasDimensionsChanged || isLoadingImage"
              (click)="onAction(true)">
      {{ 'form.button.confirm' | translate }}
  </txp-button>
</mat-dialog-actions>

<txp-loading [color]="loadingColor.COLOR" *ngIf="isLoadingImage"></txp-loading>

